/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';


import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app/app.routes';
import { GlobalErrorHandler } from './app/global-error-handler';
import { httpErrorInterceptor } from './app/http-error.interceptor';
import { ErrorHandler, provideZoneChangeDetection } from '@angular/core';


//bootstrapApplication(AppComponent, appConfig)
  //.catch((err) => console.error(err));


  
bootstrapApplication(AppComponent, {
  ...appConfig, // keep your existing config
  providers: [
    provideZoneChangeDetection(),...(appConfig.providers || []), // merge existing providers if any
    provideRouter(routes),
    provideHttpClient(withInterceptors([httpErrorInterceptor])),
    { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ]
}).catch(err => console.error(err));

